import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"
import CustomerTenantRemoveMenuItem from "@/v2-backoffice-client/customer/tenant/remove/CustomerTenantRemoveMenuItem"
import TenantExternalToolMenuItems from "@/v2-backoffice-client/tenant/TenantExternalToolMenuItems"
import TenantUpdateMenuItem from "@/v2-backoffice-client/tenant/update/TenantUpdateMenuItem"
import TenantCustomerAddSelectorDialogMenuItem from "@/v2-backoffice-client/tenant/customer/add/TenantCustomerAddSelectorDialogMenuItem"
import TenantRemoveMenuItem from "@/v2-backoffice-client/tenant/remove/TenantRemoveMenuItem"
import TenantRestoreMenuItem from "@/v2-backoffice-client/tenant/restore/TenantRestoreMenuItem"

export type CustomerTenantTableRowToolbarProps = {
  customerId: number
  customerName: string
  tenant: TenantFragment
}

function CustomerTenantTableRowToolbar(
  props: CustomerTenantTableRowToolbarProps,
) {
  const { customerId, customerName, tenant } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        <CustomerTenantRemoveMenuItem
          customerId={customerId}
          tenantId={tenant.Id}
          customerName={customerName}
          tenantName={tenant.Name}
        />

        <ActionMenu.Separator />

        <ActionMenu.Label>Team Actions</ActionMenu.Label>

        <div className="pl-2">
          <TenantExternalToolMenuItems
            tenantId={tenant.Id}
            externalCustomerId={tenant.ExternalCustomerId}
            billingAccountUuid={tenant.BillingAccountUuid}
          />

          <ActionMenu.Separator />

          <TenantUpdateMenuItem tenant={tenant} />
          <TenantCustomerAddSelectorDialogMenuItem
            tenantId={tenant.Id}
            tenantName={tenant.Name}
            externalCustomerId={tenant.ExternalCustomerId}
          />

          <ActionMenu.Separator />

          {tenant.IsDeleted ? (
            <TenantRestoreMenuItem tenantId={tenant.Id} />
          ) : (
            <TenantRemoveMenuItem tenantId={tenant.Id} />
          )}
        </div>
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default CustomerTenantTableRowToolbar
